import tw from "twin.macro";
export const ButtonWrapper = tw.div`tw-mr-6`;
